<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template>
	<div class="text-center">
		<k-btn style="background-color:#E3F2FD; height:92px; width:500px; font-size:32px;" class="k-nocaps-btn k-tight-btn" color="blue darken-4" outlined @click="show_daily_lessons_clicked">
			Daily Lesson Plans
			<k-icon style="font-size:32px" class="ml-4">fas fa-flag-checkered</k-icon>
		</k-btn>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	computed: {
	},	
	methods: {
		show_daily_lessons_clicked() { vapp.daily_lessons_showing = true },
	}
}
</script>

<style lang="scss">
</style>
